import {
  selectOrder,
  selectCompletedOrder,
  selectOrderLoading,
  selectOrderError,
  selectIsItemBeingAdded,
  selectIsItemBeingRemoved,
  selectErrorProcessingItem,
  selectLastAddedItem,
  selectSubmittingPromoCode,
  selectSubmittingPromoCodeError,
  selectUpdatingTip,
  selectUpdatingTipError,
  selectTransaction,
  selectTransactionProcessing,
  selectTransactionError,
  selectTimeout,
} from '../core/reducers/order.reducer';

/**
 * Order Selectors
 */
export const getOrder = selectOrder;
export const getCompletedOrder = selectCompletedOrder;
export const getOrderLoading = selectOrderLoading;
export const getOrderError = selectOrderError;

export const getOrderIsItemBeingAdded = selectIsItemBeingAdded;
export const getOrderIsItemBeingRemoved = selectIsItemBeingRemoved;
export const getOrderErrorProcessingItem = selectErrorProcessingItem;
export const getOrderLastAddedItem = selectLastAddedItem;

export const getOrderSubmittingPromoCode = selectSubmittingPromoCode;
export const getOrderSubmittingPromoCodeError = selectSubmittingPromoCodeError;

export const getOrderUpdatingTip = selectUpdatingTip;
export const getOrderUpdatingTipError = selectUpdatingTipError;

export const getOrderTransaction = selectTransaction;
export const getOrderTransactionProcessing = selectTransactionProcessing;
export const getOrderTransactionError = selectTransactionError;

export const getOrderTimeout = selectTimeout;
